import React, { useContext, useEffect, useState } from "react";
import { SvgImages } from "../../Utils/LocalImages";
import { ConfirmationModalTheme, ImageFilters } from "../../Utils/Enums";
import { toast } from "react-toastify";
import ButtonWithIcon from "../../Components/Reusable/ButtonWithIcon";
import Image from "../../Components/Reusable/Image";
import ConfirmationModal from "../../Components/modal/ConfirmationModal";
import generatePaginationFooter from "../../Components/Reusable/CustomPagination";
import StudyMaterialService from "../../Services/StudyMaterialService";
import RoutesPath from "../../Utils/RoutesPath";
import { useNavigate } from "react-router-dom";
import { handleApiErrors } from "../../Utils/Utils";
import CustomDropDown from "../../Components/Reusable/CustomDropDown";
import ClassService from "../../Services/ClassService";
import SubjectService from "../../Services/SubjectService";
import { useForm } from "react-hook-form";
import { yupResolver } from "@hookform/resolvers/yup";
import { InputType, validationRegex } from "../../Utils/Utils";
import * as yup from "yup";
import DataProvider from "../../Utils/DataProvider";
import { AuthContext } from "../../Context/authContext";



const StudyMaterial = () => {
  const [data, setData] = useState([]);
  const [deleteId, setDeleteId] = useState("");
  const [showDeleteModal, setShowDeleteModal] = useState(false);
  const [showConfirmationModal, setShowConfirmationModal] = useState(false);
  const [isMultipleDelete, setIsMultipleDelete] = useState(false);
  const [getStatusChangeData, setStatusChangeData] = useState({});
  const [offset, setOffset] = useState(0);
  const [limit, setLimit] = useState(10);
  const [availableDataCount, setAvailableDataCount] = useState(0);
  const [searchQuery, setSearchQuery] = useState(null);
  const [classes, setClasses] = useState([]);
  const [selectedClass, setSelectedClass] = useState("");
  const [subjects, setSubjects] = useState([]);
  const [selectedSubject, setSelectedSubject] = useState("");
  const [mediumList, setMediumList] = useState(DataProvider.mediumList);
  const [selectedMedium, setSelectedMedium] = useState("");
  const [studyMaterial, setStudyMaterial] = useState({});
  const [resetSubject, setResetSubject] = useState(false);
  const{user}=useContext(AuthContext)


  const navigate = useNavigate();

  const stepOneValidations = yup.object().shape({
    class_id: validationRegex.required,
    subject: validationRegex.required,
    medium: validationRegex.required
  });

  const { register: registerStepOne, handleSubmit: handleSubmitStepOne, setValue: setValuesStepOne, formState: { errors: errorsStepOne }, watch: watchStepOne, getValues: getValuesStepOne, reset: resetStepOne } = useForm({
    resolver: yupResolver(stepOneValidations),
    defaultValues: {
      class_id: studyMaterial ? studyMaterial?.class_id : "",
      subject: studyMaterial ? studyMaterial?.subject_id : "",
      medium: studyMaterial ? studyMaterial?.medium : "",
    },
  });

  useEffect(() => {
    if (selectedClass) {
      getAllSubjects(selectedClass);
    }else{
      setSubjects([]);
    }
  }, [selectedClass]);

  const getAllClasses = async () => {
    try {
      const response = await ClassService.getAllClassesWithoutPagination();
      setClasses(response.data);

    } catch (error) {
      handleApiErrors(error);
    }
  };

  const getAllSubjects = async (classId) => {
    try {
      const response = await SubjectService.getAllSubjectsWithoutPagination(classId);
      setSubjects(response.data);
    } catch (error) {
      handleApiErrors(error);
    }
  };

  useEffect(() => { getAllClasses() }, []);
  
  const fetchData = async () => {
    try {
      const response = await StudyMaterialService.getAllStudyMaterials(
        offset,
        limit,
        searchQuery || "",
        selectedClass || "",
        selectedSubject || "",
        selectedMedium || ""
      );
      setData(response.data);
      setAvailableDataCount(response.availableDataCount);
      if (offset != 0 && offset * limit > availableDataCount - 1) {
        setOffset(offset - 1);
      }
    } catch (error) {
      handleApiErrors(error);
    }
  };

  const deleteSingleStudyMaterial = async (id) => {
    try {
      await StudyMaterialService.deleteStudyMaterial([id]);
      toast.success("Study Material Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const deleteMultipleStudyMaterials = async () => {
    try {
      if (data?.findIndex((item) => item.isChecked) != -1) {
        var itemsToDelete = [];
        data.map((item) => {
          if (item.isChecked) {
            itemsToDelete.push(item.id);
          }
        });
      }
      await StudyMaterialService.deleteStudyMaterial(itemsToDelete);
      toast.success("Study Materials Deleted successfully");
      setShowDeleteModal(false);
      setOffset(0);
      fetchData();
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  const ChangeStatus = async (id, status) => {
    try {
      await StudyMaterialService.updateStudyMaterialStatus(id, status);
      toast.success("Study Material Status Updated successfully");

      var updatedData = data;
      updatedData[updatedData?.findIndex((item) => item.id === id)].is_active =
        status;
      setData(updatedData);

      setShowConfirmationModal(false);
    } catch (error) {
      console.error("Error deleting item:", error);
    }
  };

  useEffect(() => {
    fetchData();
  }, [offset, selectedClass, selectedMedium, selectedSubject]);

  useEffect(() => {
    const timeOutId = setTimeout(() => {
      setOffset(0);
      if (searchQuery != null) {
        fetchData();
      }
    }, 500);
    return () => clearTimeout(timeOutId);
  }, [searchQuery]);

  return (
    <div>
      <div className="content" data-number="1">
        <div className="mb-3 d-flex justify-content-between align-items-center">
          <h1 className="black fs-18 fw-600 mb-0">STUDY MATERIAL</h1>
          <div className="d-flex">
            <h4 className="fs-12 fw-500 black mb-0 me-1">Dashboard &gt;</h4>
            <h4 className="fs-12 fw-500 primary mb-0">Study Material</h4>
          </div>
        </div>

        <div className="table_container" style={{ display: "block" }}>
          <h1 className="black fs-18 fw-600 mb-0">Study Material List</h1>

          <div className="table_title">
            <div className="table_headings mt-2 Commonclass">
              <h1 className="black fs-18 fw-600 mb-0">
                <div
                  className="table_delete_icon"
                  style={{
                    opacity:
                      data?.findIndex((item) => item.isChecked) == -1 ? 0.3 : 1,
                      pointerEvents: data?.findIndex((item) => item.isChecked) === -1 ? 'none' : 'auto',
                  }}
                  onClick={() => {

                    const studyMaterialPrivilege = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Study material"
                    );

                    if (!studyMaterialPrivilege?.delete) {
                      // If the user does not have delete permission, show a toast warning
                      toast.warning("You don't have permission to delete study material.");
                      return;
                    }

                    if (!(data.findIndex((item) => item.isChecked) == -1)) {
                      setIsMultipleDelete(true);
                      setShowDeleteModal(true);
                    }
                  }}
                >
                  <Image src={SvgImages.deleteIcon} alt="Delete Icon" />
                </div>
              </h1>

              <div className="d-flex gap-4 align-items-center Responsivesection">
                <div className="position-relative">
                  <input
                    type="search"
                    className="search_box search_bar"
                    placeholder="Search"
                    onChange={(e) => {
                      setSearchQuery(e.target.value);
                    }}
                  />
                  <Image
                    src={SvgImages.search}
                    style={ImageFilters.gray}
                    className="search_icon"
                    alt="Search Icon"
                    height="20px"
                  />
                </div>

                <ButtonWithIcon
                  text={"Add Study Material"}
                  icon={SvgImages.plus}
                  onClick={() => {

                    const studyMaterialPrivilege = user?.setPrivileges?.find(
                      (priv) => priv.parameter === "Study material"
                    );
                    if (studyMaterialPrivilege?.create) {
                      navigate(RoutesPath.addStudyMaterial)
                    }else{
                      toast.warning("You don't have permission to add a Study Material.")
                    }
                    }}
                />
              </div>
            </div>


          </div>
          <div className="row profile_inputs w-100 Responsivesearchbars">
            <div className="col-md-4">
              <CustomDropDown
                placeholder="Filter By Class"
                name="class_id"
                id="class_id"
                additionalClasses="profile_edit"
                inputType={InputType.text}
                register={registerStepOne}
                setValue={setValuesStepOne}
                onChange={(e) => {
                  setSelectedSubject("");
                  setResetSubject(true);
                  setSelectedClass(e.value);
                  setOffset(0)
                }}
                options={
                  [{ value: "", label: "All" }, ...classes.map((e) => { return { value: e._id, label: e.class_name } }) ?? []]
                }
              />
            </div>

            <div className="col-md-4">
              <CustomDropDown
                placeholder="Filter by Subject"
                name="subject"
                id="subject"
                additionalClasses="profile_edit"
                resetValue={resetSubject}
                setResetValue={setResetSubject}
                inputType={InputType.text}
                register={registerStepOne}
                setValue={setValuesStepOne}
                onChange={(e) => {
                  setSelectedSubject(e.value);
                  setOffset(0);
                }}
                options={
                  [{ value: "", label: "All" }, ...subjects?.map((e) => { return { value: e._id, label: e.subject_name } }) ?? []]
                }
              />
            </div>

            <div className="col-md-4">
              <CustomDropDown
                placeholder="Filter By Medium"
                name="medium"
                id="medium"
                additionalClasses="profile_edit"
                inputType={InputType.text}
                register={registerStepOne}
                setValue={setValuesStepOne}
                options={
                  [{ value: "", label: "All" }, ...mediumList ?? []]
                }
                onChange={(e) => {
                  setSelectedMedium(e.value);
                  setOffset(0);
                }}
              />
            </div>


          </div>

          <div style={{ overflowX: "auto" }}>
            <table
              className="table mb-0"
              id="dtHorizontalExample"
              cellSpacing="0"
              width="100%"
            >
              <thead>
                <tr className="table_heading">
                  <th scope="col" style={{ width: "5%" }}>
                    <label className="d-flex align-items-center justify-content-center">
                      <input
                        className="cursor-pointer"
                        type="checkbox"
                        style={{ height: "16px", aspectRatio: 1 }}
                        checked={
                          data?.length > 0 &&
                          data.findIndex((item) => !item.isChecked) == -1
                        }
                        onChange={(value) => {
                          var updatedData = data;
                          updatedData.map((element) => {
                            element.isChecked = value.target.checked;
                          });
                          setData([...updatedData]);
                        }}
                      />
                      <span className="checkmark"></span>
                    </label>
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Sr No.
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Class
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Medium
                  </th>
                  <th scope="col" style={{ width: "20%" }}>
                    Subject
                  </th>
                  <th scope="col" style={{ width: "15%" }}>
                    Status
                  </th>
                  <th scope="col" style={{ width: "10%" }}>
                    Action
                  </th>
                </tr>
              </thead>
              <tbody className="bg_light">
                {data?.map((item, index) => (
                  <tr key={index}>
                    <td>
                      <label className="d-flex align-items-center justify-content-center">
                        <input
                          className="cursor-pointer"
                          type="checkbox"
                          checked={item.isChecked || false}
                          style={{ height: "16px", aspectRatio: 1 }}
                          onChange={(value) => {
                            var updatedData = data;
                            updatedData[index].isChecked =
                              value.target.checked;
                            setData([...updatedData]);
                          }}
                        />
                        <span className="checkmark"></span>
                      </label>
                    </td>
                    <td>{limit * offset + (index + 1)}</td>
                    <td>{item.class_name}</td>
                    <td>{item.medium}</td>
                    <td>{item.subject_name}</td>
                    <td>
                      <label
                        className="switch"
                        data-bs-target="#change_status"
                        data-bs-toggle="modal"
                      >
                        <input
                          type="checkbox"
                          checked={item.is_active}
                          onChange={() => {

                          const studyMaterialPrivilege = user?.setPrivileges?.find(
                            (priv)=>priv.parameter ==="Study material"
                          )

                          
                          if (!studyMaterialPrivilege?.update) {
                            // If the user does not have delete permission, show a toast warning
                            toast.warning("You don't have permission to update the status.");
                            return;
                          }


                            setShowConfirmationModal(true);
                            setStatusChangeData(item);
                          }}
                        />
                        <span className="slider round"></span>
                      </label>
                    </td>
                    <td>
                      <div className="d-flex gap_8">
                        <a
                          onClick={() =>{

                            const studyMaterialPrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Study material"
                            );
  
                            if (!studyMaterialPrivilege?.update) {
                              // If the user does not have delete permission, show a toast warning
                              toast.warning("You don't have permission to edit study material.");
                              return;
                            }
                          
                            navigate(RoutesPath.editStudyMaterial, {
                              state: item,
                            })
                          }}
                          className="edit_icons cursor-pointer"
                          data-bs-target="#editclass"
                          data-bs-toggle="modal"
                        >
                          <Image
                            src={SvgImages.edit}
                            style={ImageFilters.green}
                            className="add_icons"
                            alt="Edit Icon"
                          />
                        </a>
                        <a
                          className="delete_icons cursor-pointer"
                          onClick={() => {

                            const studyMaterialPrivilege = user?.setPrivileges?.find(
                              (priv) => priv.parameter === "Study material"
                            );
  
                            if (!studyMaterialPrivilege?.delete) {
                              // If the user does not have delete permission, show a toast warning
                              toast.warning("You don't have permission to delete study material.");
                              return;
                            }
                            setDeleteId(item.id);
                            setIsMultipleDelete(false);
                            setShowDeleteModal(true);
                          }}
                        >
                          <Image
                            src={SvgImages.deleteIcon}
                            style={ImageFilters.red}
                            data-bs-target="#delete-modal"
                            data-bs-toggle="modal"
                            alt="Delete Icon"
                          />
                        </a>
                      </div>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>


          </div>
          {generatePaginationFooter(
            availableDataCount,
            limit,
            offset,
            setOffset
          )}
        </div>
      </div>


      {/* Delete Study Material Modal */}
      <ConfirmationModal
        showModal={showDeleteModal}
        setShowModal={setShowDeleteModal}
        text={
          isMultipleDelete
            ? "Are you sure want to delete selected study materials?"
            : "Are you sure want to delete this study material?"
        }
        icon={SvgImages.deleteIcon} // Specify the path to your delete icon
        rightClickAction={() => {
          isMultipleDelete
            ? deleteMultipleStudyMaterials()
            : deleteSingleStudyMaterial(deleteId);
        }}
        theme={ConfirmationModalTheme.error}
      />

      {/* Change Study Material Status Modal */}
      <ConfirmationModal
        showModal={showConfirmationModal}
        setShowModal={setShowConfirmationModal}
        text={"Are you sure want to change the status?"}
        icon={SvgImages.exclamation_mark} // Specify the path to your delete icon
        rightClickAction={() => {
          ChangeStatus(getStatusChangeData.id, !getStatusChangeData.is_active);
        }}
        theme={ConfirmationModalTheme.warning}
      />
    </div>
  );
};

export default StudyMaterial;
